import { Row } from "antd";
import Conversations from "./Conversations";
import { StyledConversationWrapper } from "./styles";
import { useTenantTopics } from "../../../hooks/useTenantTopics";
import { useTenantChats } from "../../../hooks/useTenantChats";
import { useTenantUsers } from "../../../hooks/useTenantUsers";
import ChatWindow from "./ChatWindow";
import { useEffect, useState } from "react";
import TicketInfo from "./TicketInfo";
import ProductivityHub from "./ProductivityHub";
import useBreakpoint from "../../../hooks/useBreakpoint";
import ConversationsWidget from "./Conversations/ConversationsWidget";

const Chats = () => {
  const {
    chats,
    loading,
    selectedChatId,
    newMessageCount,
    selectedChat,
    selectedTenantId,
  } = useTenantChats();
  const { topics } = useTenantTopics();
  useTenantUsers();

  const [isShowTicketInfo, setIsShowTicketInfo] = useState(false);
  const [isShowProductivity, setIsShowProductivity] = useState(false);

  useEffect(() => {
    if (selectedChatId && !isShowProductivity) setIsShowProductivity(true);
  }, [selectedChatId]);

  const { md } = useBreakpoint();

  return (
    <StyledConversationWrapper>
      <Row
        className={`h-100 ${selectedChatId ? "chat-window-open" : "conversations-panel-open"}`}
      >
        {!md && (
          <Conversations
            chats={chats}
            topics={topics}
            loading={loading}
            selectedChatId={selectedChatId}
            newMessageCount={newMessageCount}
          />
        )}
        <ChatWindow
          options={{
            isShowTicketInfo,
            setIsShowTicketInfo,
            isShowProductivity,
            setIsShowProductivity,
          }}
        />
        {isShowTicketInfo && (
          <TicketInfo
            selectedChat={selectedChat}
            tenant_id={selectedTenantId}
            setIsShowTicketInfo={setIsShowTicketInfo}
          />
        )}
        {isShowProductivity && (
          <ProductivityHub
            setIsShowProductivity={setIsShowProductivity}
            conversation_id={selectedChat?.id}
            tenant_id={selectedTenantId}
          />
        )}
      </Row>
      {md && (
        <ConversationsWidget
          chats={chats}
          topics={topics}
          loading={loading}
          selectedChatId={selectedChatId}
          newMessageCount={newMessageCount}
        />
      )}
    </StyledConversationWrapper>
  );
};

export default Chats;
